import { createEvent } from "library/local-events/index.mjs"

export const AssetRegisterDisplayFields = createEvent("AssetRegisterDisplayFields", {
    extract: (v) => v[0].displayFields,
})

const TAG_COLUMN = {
    field: "tag",
    label: "Asset Tag",
    description: "The asset tag is the unique id you have for an asset.",
    required: true,
}

export function buildRegisterColumns(displayFields = [], { typeLabel } = {}) {
    return [TAG_COLUMN, { field: "description" }, { field: "type", label: typeLabel }, ...displayFields].map(toColumn)
}

function toColumn(field) {
    return {
        ...field,
        label: field.label ?? toLabel(field.field),
        pinnable: true,
        hideable: !field.required,
    }
}

function toLabel(fieldName) {
    return fieldName.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase())
}
